import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API from '../utils/api';
import './Result.css';

const VIOLATION_LABELS = {
  tab_change: 'Pindah Tab',
  window_blur: 'Keluar Jendela',
  face_missing: 'Wajah Tidak Terdeteksi',
  face_multiple: 'Banyak Wajah',
  copy_attempt: 'Percobaan Copy-Paste',
  fullscreen_exit: 'Keluar Fullscreen'
};

export default function Result() {
  const { session_id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get(`/exam/result/${session_id}`)
      .then(res => setData(res.data))
      .catch(() => navigate('/dashboard'))
      .finally(() => setLoading(false));
  }, [session_id, navigate]);

  if (loading) return <div className="loading-screen"><div className="spinner"></div></div>;
  if (!data) return null;

  const { session, violations } = data;
  const passed = !session.is_disqualified && session.score >= 60;

  return (
    <div className="result-page">
      <div className="result-container">
        <div className={`result-header ${session.is_disqualified ? 'disq' : passed ? 'pass' : 'fail'}`}>
          <div className="result-icon">
            {session.is_disqualified ? '🚫' : passed ? '🎉' : '😔'}
          </div>
          <h1>
            {session.is_disqualified ? 'Didiskualifikasi' : passed ? 'Lulus!' : 'Tidak Lulus'}
          </h1>
          <p className="result-name">{session.candidate_name || 'Peserta'}</p>
        </div>

        <div className="result-score-box">
          <div className="score-big">{session.score}%</div>
          <div className="score-label">Nilai Akhir</div>
          <div className="score-pass">Nilai Minimum Lulus: 60%</div>
        </div>

        <div className="result-stats">
          <div className="stat-item">
            <span className="stat-val">{session.violation_count}</span>
            <span className="stat-label">Total Pelanggaran</span>
          </div>
          <div className="stat-item">
            <span className="stat-val">{session.status === 'disqualified' ? 'GUGUR' : 'SELESAI'}</span>
            <span className="stat-label">Status</span>
          </div>
        </div>

        {violations.length > 0 && (
          <div className="violations-section">
            <h3>📋 Log Pelanggaran</h3>
            <div className="violation-list">
              {violations.map((v, i) => (
                <div key={v.id} className="violation-item">
                  <span className="v-num">{i + 1}</span>
                  <div className="v-info">
                    <span className="v-type">{VIOLATION_LABELS[v.violation_type] || v.violation_type}</span>
                    <span className="v-desc">{v.description}</span>
                    <span className="v-time">{new Date(v.logged_at).toLocaleString('id-ID')}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <button className="btn-primary" onClick={() => navigate('/dashboard')}>
          Kembali ke Dashboard
        </button>
      </div>
    </div>
  );
}
